import { makeStyles, Theme } from '@material-ui/core/styles';
export const useCustomPointStyles = makeStyles((theme: Theme) => ({
    point: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '15px',
        fontWeight: 300,
        fontSize: '18px',
        lineHeight: '21px',
        color: theme.colors.white,
    },
    checkIcon: { marginRight: '19px', width: '20px', height: '15px' },
}));
